import script from "./GabineteAgendaCalendarioPage.vue?vue&type=script&setup=true&lang=js"
export * from "./GabineteAgendaCalendarioPage.vue?vue&type=script&setup=true&lang=js"

import "./GabineteAgendaCalendarioPage.vue?vue&type=style&index=0&id=4b9a0eea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b9a0eea"]])

export default __exports__